angular.module('callX').controller('CampaignsApplySingleCtrl', ['$scope', '$modal','CampaignsService', '$stateParams', 'toaster', 'UserService', '$state','DataService', function($scope, $modal,CampaignsService, $stateParams, toaster, UserService, $state,DataService) {

//    console.log("$stateParams.campaignId",$stateParams.campaignId);

    $scope.campaignId = $stateParams.campaignId;
    $scope.campaign = {};
    $scope.countryCodes = DataService.getCountryCodes();
    $scope.textIVRDetails = {};
    $scope.textIVRDetails.country = "1";

    var fetchCampaignData = function(){
        var callbacks = {
            success: function(data) {
//                console.log("data",data);
                $scope.campaign = data.data;
            },
            failure: function(data) {

            }
        };
        CampaignsService.getCampaignsData($scope.campaignId, callbacks);
    };

    $scope.textIVR = function(){
        $scope.textIVRDetails.campaign_id = $scope.campaignId;
        $scope.textIVRDetails.from = $scope.textIVRDetails.country + $scope.textIVRDetails.from_number;
//        console.log("$scope.textIVRDetails",$scope.textIVRDetails);

        if ($scope.textIVRDetails.country == undefined) {
            toaster.pop('error', 'Error',  'Country code is required.', 2000);
        }

        else if ($scope.textIVRDetails.from_number == undefined) {
            toaster.pop('error', 'Error', 'Phone Number is required', 2000);
        }

        if ($scope.textIVRDetails.country != undefined && $scope.textIVRDetails.from_number!= undefined) {
            var callbacks = {
                success: function (data) {
                    if(data.status == "error") {
                        toaster.pop('error', 'Error Occurred', data.data);
                    } else {
                        toaster.pop('success', 'Success', 'Call is now in progress', 2000);
                        $scope.showIVRForm = 0;
                        $scope.textIVRDetails.from_number = '';
                    }
                },
                failure: function (data) {
                    $scope.showIVRForm = 0;
                }
            };
            CampaignsService.testIVR($scope.textIVRDetails, callbacks);
        }
    };

    $scope.applyToThisCampaign = function(){

        if ($scope.applicationDescription == undefined) {
            toaster.pop('error', 'Application Information',  'Application Information is required.', 2000);
        }

        else if ($scope.agreed == undefined) {
            toaster.pop('error', 'Agreement to terms', 'Please agree to the Terms of Service', 2000);
        }

        if ($scope.applicationDescription != undefined && $scope.agreed != undefined) {
            var currentUserData = UserService.getCurrentUserData();
            $scope.applicationDetails = {"user_id":currentUserData.id,"application_description":$scope.applicationDescription,"terms":$scope.agreed};
            var callbacks = {
                success: function (data) {
                    if (data.statusCode == 200) {
                        $state.go('app.campaigns.list');
                        toaster.pop('success', 'Success', 'Campaign successfully applied', 2000);
                    }
                    else {
                        if (data.statusCode == 401) {
                            toaster.pop('error', 'Error', data.data);
                        }
                    }
                },
                failure: function (data) {
                    toaster.pop('error', 'Error Occurred', data.data);
                }
            };
            CampaignsService.applyToThisCampaign($scope.campaignId, $scope.applicationDetails, callbacks);
        }
    };

    fetchCampaignData();
    $scope.openCopyConfirmationModal = function(){
         var dialogInst = $modal.open({
                  templateUrl: 'tpl/blocks/terms_of_service.html',
                  controller: 'TOSCtrl',
                  size: 'lg'
    });
    }; 
}]);